import { gql, useQuery } from "@apollo/client"
import { PRINTER_FIELDS } from "./fragments/printerFieldsFragment"

export const GET_PRINTERS_QUERY = gql`
  query PrintersByLocation($filter: PrinterFilterInput) {
    printers(filter: $filter) {
      list {
        ...PrinterFields
      }
    }
  }
  ${PRINTER_FIELDS}
`

const useQueryPrinters = (variables, options = {}) => {
  const queryOptions = {
    variables,
    ...options
  }

  return useQuery(GET_PRINTERS_QUERY, queryOptions)
}

const printersTypePolicies = {
  root: {},
  scoped: {
    USBPrinter: {
      fields: {
        deviceName: {
          read(_, { readField }) {
            return readField("address")
          }
        }
      }
    }
  }
}

export { useQueryPrinters, printersTypePolicies }
